import { USER_ROLES } from '#common/constants';
import {
  ADDONS,
  PRICE_MODEL,
  BILLING_CYCLE,
} from '#common/constants/addons';

import icon from './assets/SWMSalesperson.jpg';

import type { Addon } from '../types';

function Description() {
  return (
    <>
      <div>
        The <b>SWM</b> (S)mall (W)arehouse (M)anagement <b>Salesperson Module</b> enhances the SWM platform by providing below features:
      </div>
      <br />
      <div>
        For admins:
        <ul>
          <li>A new user type: <b>salesperson</b> will be added for the admins when creating new users.</li>
          <li>The admins can assign/reassign customers to a salesperson.</li>
          <li>The admins can set commission percentages for salesperson: <b>sample item</b> and <b>reorder item</b>.</li>
          <li>The admins will be able to set a specific order item as a <b>sample item</b> or a <b>reorder item</b>.</li>
          <li>The admins can set collection restrictions for a salesperson, and <b> that will be the suberset of his customers</b>.</li>
          <li>The admins will be able to see all salseperson <b>commission reports</b> by selected date range.</li>
          <li>The salesperson commission report includes <b>the inteligent commission cheating detection</b>.</li>
          <li>The reports can be <b>printed (PDF)</b> and <b>exported (CSV)</b>.</li>
        </ul>
      </div>
      <div>
        For salespersons:
        <ul>
          <li>A salseperson can create <b>customers</b> by his account, and <b>his will earn commissions from the customer orders</b>.</li>
          <li>A salesperson can set <b>sub-</b>collection restrictions for his customers.</li>
          <li>A salesperson will be able to see his own <b>commission reports</b> by selected date range.</li>
          <li>The reports can be <b>printed (PDF)</b> and <b>exported (CSV)</b>.</li>
        </ul>
      </div>
    </>
  );
}

const addon: Addon = {
  apply: (bootstrap) => {
    // add nested panel menu item
    const targetPanel = bootstrap.panel.find((p) => p.label === 'Warehouse Analysis');
    if (targetPanel) {
      targetPanel.children?.push({
        testid: 'salesperson-report',
        label: 'Salesperson Report',
        link: '/management/salesperson/report',
        linkAlias: ['management/salesperson/report'],
        roles: USER_ROLES.ADMIN_AND_SALESPERSON,
      });
    }
  },

  info: {
    id: ADDONS.SALESPERSON,
    available: true,
    name: 'SWM Salesperson',
    version: '1.0',
    icon,
    descriptionText: 'SWM Salesperson module opens up the ability to create salesperson accounts, as well as automitically generate the salesperson commission reports by selected date range.',
    descriptionComponent: <Description />,
    priceModel: PRICE_MODEL.CONTINUES_SUBSCRIPTION,
    prices: [{
      price: '99.99',
      cycle: BILLING_CYCLE.MONTHLY,
    }, {
      price: '1199.99',
      cycle: BILLING_CYCLE.ANNUALLY,
    }],
  },
};

export default addon;
